import Header from "@Components/Header/Header"
import { MobHeader } from "@Components/Mob-header/Mob-header"
import { ContactusIndex } from "@Src/features/contactus/contact"
import HomeLayout from "@Src/features/layout/components/HomeLayout/HomeLayout"


export const Contactus =() => {

    return (
        <>
        {/* <Header/>
        <MobHeader/> */}
        <HomeLayout>
            <ContactusIndex/>
        </HomeLayout>
        </>
    )
}